module.exports = __webpack_public_path__ + "img/228.8575f892.jpg";